import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  IconButton,
  Chip,
  Tooltip,
  Button,
  Dialog,
} from '@mui/material';
import {
  Description as DocumentIcon,
  CheckCircle as ApproveIcon,
  Close as RejectIcon,
  History as PendingIcon,
  Info as InfoIcon,
} from '@mui/icons-material';

const DocumentRequestQueue = () => {
  const [requests, setRequests] = useState([
    {
      id: 1,
      title: 'Grant Application Review',
      type: 'approval',
      status: 'pending',
      requester: 'Project A',
      date: '2024-03-07',
      priority: 'high',
      documents: ['grant_application.pdf', 'budget.xlsx']
    },
    // Add more sample requests
  ]);

  const handleApprove = (requestId) => {
    setRequests(requests.map(req => 
      req.id === requestId ? { ...req, status: 'approved' } : req
    ));
  };

  const handleReject = (requestId) => {
    setRequests(requests.map(req => 
      req.id === requestId ? { ...req, status: 'rejected' } : req
    ));
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'approved': return '#4CAF50';
      case 'rejected': return '#f44336';
      case 'pending': return '#ff9800';
      default: return '#757575';
    }
  };

  return (
    <Paper sx={{ 
      backgroundColor: 'rgba(18, 18, 18, 0.95)',
      borderRadius: 2,
      p: 3,
      mb: 3
    }}>
      <Typography variant="h6" sx={{ 
        color: '#fff',
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1
      }}>
        <DocumentIcon sx={{ color: '#00BCD4' }} />
        Document Requests Queue
      </Typography>

      <List>
        {requests.map((request) => (
          <ListItem
            key={request.id}
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.05)',
              borderRadius: 1,
              mb: 1,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
              }
            }}
          >
            <ListItemIcon>
              <DocumentIcon sx={{ color: '#00BCD4' }} />
            </ListItemIcon>
            
            <ListItemText
              primary={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography sx={{ color: '#fff' }}>
                    {request.title}
                  </Typography>
                  <Chip
                    label={request.priority}
                    size="small"
                    sx={{
                      backgroundColor: request.priority === 'high' ? 'rgba(244, 67, 54, 0.1)' : 'rgba(255, 152, 0, 0.1)',
                      color: request.priority === 'high' ? '#f44336' : '#ff9800'
                    }}
                  />
                </Box>
              }
              secondary={
                <Box sx={{ 
                  color: 'rgba(255, 255, 255, 0.7)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  mt: 0.5
                }}>
                  <Typography variant="body2">
                    {request.requester}
                  </Typography>
                  <Typography variant="body2">
                    {request.date}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    {request.documents.map((doc, index) => (
                      <Chip
                        key={index}
                        label={doc}
                        size="small"
                        sx={{
                          backgroundColor: 'rgba(0, 188, 212, 0.1)',
                          color: '#00BCD4',
                          fontSize: '0.75rem'
                        }}
                      />
                    ))}
                  </Box>
                </Box>
              }
              sx={{
                '& .MuiListItemText-primary': { color: '#fff' },
                '& .MuiListItemText-secondary': { color: 'rgba(255, 255, 255, 0.7)' }
              }}
            />

            <ListItemSecondaryAction sx={{ display: 'flex', gap: 1 }}>
              <Chip
                label={request.status}
                sx={{
                  backgroundColor: `${getStatusColor(request.status)}20`,
                  color: getStatusColor(request.status),
                  mr: 2
                }}
              />
              {request.status === 'pending' && (
                <>
                  <Tooltip title="Approve">
                    <IconButton 
                      onClick={() => handleApprove(request.id)}
                      sx={{ 
                        color: '#4CAF50',
                        '&:hover': { backgroundColor: 'rgba(76, 175, 80, 0.1)' }
                      }}
                    >
                      <ApproveIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Reject">
                    <IconButton 
                      onClick={() => handleReject(request.id)}
                      sx={{ 
                        color: '#f44336',
                        '&:hover': { backgroundColor: 'rgba(244, 67, 54, 0.1)' }
                      }}
                    >
                      <RejectIcon />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Paper>
  );
};

export default DocumentRequestQueue; 